// oxlint-disable-next-line endla/no-compiler-opt-out -- Existing code
"use no memo";

import proj4 from "proj4";

export const WGS84toWebMercator = proj4("WGS84", "EPSG:3857");
export const WebMercatorToWGS84 = proj4("EPSG:3857", "WGS84");

export const EPSG_28355 =
  "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";

export const EPSG_7855 =
  "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs";
